import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { addAsyncCasesNew, addTakeLatestResourceFactory } from 'shared/utils/redux';

import { GlobalQuestionLibraryState, STORE_NAME } from './initialState';
import {
  fetchGlobalQuestionLibraryCategories,
  fetchGlobalQuestionLibraryChanges,
  fetchGlobalQuestionLibraryQuestions,
} from './asyncActions';

const addTakeLatestResource = addTakeLatestResourceFactory<GlobalQuestionLibraryState.Domain>();

export const globalQuestionLibrarySlice = createSlice({
  name: STORE_NAME,
  initialState: GlobalQuestionLibraryState.INITIAL_DOMAIN,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<GlobalQuestionLibraryState.Domain>) => {
    addAsyncCasesNew(builder, fetchGlobalQuestionLibraryQuestions, (state, action) => {
      state.questions = action.payload;
    });

    addAsyncCasesNew(builder, fetchGlobalQuestionLibraryCategories, (state, action) => {
      state.categories = action.payload;
    });

    addTakeLatestResource(builder, fetchGlobalQuestionLibraryChanges, 'changes');
  },
});
